import { createSlice } from "@reduxjs/toolkit";
import getColourEnrichments from "../thunks/getColourEnrichments";
import updateSearchTermAction from "../thunks/updateSearchTerm";
import receiveColourEnrichmentReducer from "./receiveColourEnrichment";
import updateSearchTerm from "./updateSearchTerm";

const initialState = { swatches: {}, searchTerm: "" };

const facetSlice = createSlice({
  name: "facet",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getColourEnrichments.fulfilled, receiveColourEnrichmentReducer)
      .addCase(updateSearchTermAction, updateSearchTerm);
  }
});

export const reducer = facetSlice.reducer;
